<template>
  <v-row justify="center" no-gutters>
    <v-col cols="12" lg="12" md="12" sm="12">
      <v-card :class="{ transparent: !settings }" class="py-3" flat>
        <v-card-title v-if="!!title" class="text-center justify-center">{{ title }}</v-card-title>
        <p v-if="!!description" class="text-center">{{ description }}</p>
        
        <v-card-title
          v-if="!newPosition && value.length > 1"
          class="flex-wrap justify-center pt-2"
        >
          <v-btn
            :class="gallery === 'allPic' ? 'activeBtn' : ''"
            class="px-3"
            min-width="36"
            text
            @click="gallery = 'allPic'"
          >
            {{ $t("all") }}
          </v-btn>

          <v-btn
            v-for="({ name }, i) in value"
            :key="i"
            :class="gallery === name ? 'activeBtn' : ''"
            class="px-2"
            min-width="36"
            text
            @click="gallery = name"
          >
            {{ name }}
          </v-btn>
        </v-card-title>

        <div v-if="!isGrid && !newPosition" class="w-100 px-2" >
          
          <template v-if="getObj && getObj.length <= 1" >
            <v-col
              v-for="(src, i) in getObj"
              :key="i"
              cols="12"
              md="8"
              lg="8"
              class="pa-0 text-center mx-auto"
              @click="pdfLoader(src)"
              style="min-width: 100%;"            >
              <v-img
                v-if="isImg"
                :aspect-ratio="16 / 9"
                :src="src.url || src.file_link || src.link"
                class="rounded-lg mx-auto"
                max-width="800"
              >
                <div v-if="src.description" class="b-gallery-background">
                  <pre class="text-center b-service-content pb-2" v-html="src.description" />
                  <div class="b-content-slider" />
                </div>
              </v-img>

              <template v-else style="min-width: 100%;">
                <span class="d-flex w-100 flex-column justify-content-center align-items-center">
                  <v-card-title
                    :href="!!src.link ? src.link : null"
                    :tag="!!src.link ? 'a' : 'div'"
                    class="pa-2 text-break"
                    target="_blank"
                    v-html="src.title"
                  />
                </span>
                <div style="position: relative; min-width:100%;  width: 100%; aspect-ratio: 16/9; max-height: 500px; overflow: hidden; border-radius: 8px; max-width: 800px; margin: 0 auto; background-color: #000;">
                  <iframe
                    :src="src.url || src.file_link || src.link"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; background: transparent;"
                  />
                  <!-- نشانگر زمان ویدیو -->
                  <span v-if="src.duration" class="duration-badge">{{ src.duration }}</span>
                </div>
                <v-card-text v-show="!!src.description" v-html="src.description" />
              </template>
            </v-col>
          </template>

          <!-- حالت اسلایدر مدرن برای چند آیتم -->
          <v-card v-else class="slider-card mx-auto" dark flat>
            <v-window v-model="currentItem" class="fill-height">
              <v-window-item
                v-for="(src, i) in getObj"
                :key="`window-${i}`"
              >
                <!-- تصویر -->
                <v-img
                  v-if="isImg"
                  :src="src.url || src.file_link || src.link"
                  class="fill-height"
                  :aspect-ratio="16/9"
                  @click="pdfLoader(src)"
                >
                  <template #default>
                    <!-- گرادیانت پایین تصویر برای خوانایی بهتر نوار پیشرفت -->
                    <div class="fill-height bottom-gradient"></div>
                    <!-- توضیحات روی عکس -->
                    <div v-if="src.description" class="item-description" v-html="src.description"></div>
                  </template>
                </v-img>

                <!-- ویدیو / iframe -->
                <!-- تغییرات اعمال شده برای ویدیو اسلایدر -->
                <div v-else style="position: relative; width: 100%; aspect-ratio: 16/9; max-height: 500px; overflow: hidden; background-color: #000;">
                  <iframe
                    :src="src.url || src.file_link || src.link"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"
                  ></iframe>
                  <!-- نشانگر زمان ویدیو -->
                  <span v-if="src.duration" class="duration-badge">{{ src.duration }}</span>
                  <!-- لایه گرادیانت روی ویدیو -->
                  <div class="fill-height bottom-gradient pointer-events-none"></div>
                </div>

                <!-- عنوان اصلی آیتم -->
                <div class="item-title" v-if="src.title" v-html="src.title"></div>
              </v-window-item>
            </v-window>

            <!-- کنترل‌های اسلایدر -->
            <div class="slider-controls">
              <!-- نوار خطوط تیره -->
              <div class="progress-bar-container">
                <div
                  v-for="n in (getObj || []).length"
                  :key="`progress-${n}`"
                  class="progress-dash"
                  :class="{ 'active': n - 1 === currentItem }"
                  @click="currentItem = n - 1"
                ></div>
              </div>

              <!-- دکمه‌های ناوبری -->
              <div class="nav-buttons" dir="ltr">
                <v-btn
                  icon
                  small
                  :disabled="currentItem === 0"
                  @click="currentItem--"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  :disabled="currentItem === (getObj || []).length - 1"
                  @click="currentItem++"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>

        <!-- حالت Grid (مربوط به تنظیمات قبلی شما) -->
        <v-container v-if="isGrid && !newPosition" fluid grid-list-md>
          <v-layout row wrap>
            <v-flex
              v-for="(src, i) in getObj"
              :key="i"
              md="6"
              xs="12"
              @click="pdfLoader(src)"
            >
              <v-card class="rounded-lg overflow-hidden" flat>
                <v-img
                  v-if="isImg"
                  :aspect-ratio="16 / 9"
                  :src="src.url || src.file_link || src.link"
                />
                <!-- تغییرات اعمال شده برای ویدیو گرید -->
                <div v-else style="position: relative; width: 100%; aspect-ratio: 16/9; max-height: 500px; overflow: hidden; background-color: #000;">
                   <iframe
                    :src="src.url || src.file_link || src.link"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"
                  />
                  <span v-if="src.duration" class="duration-badge">{{ src.duration }}</span>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- حالت Grid با New Position -->
        <v-container
          v-for="(src, idx) in value"
          v-if="isGrid && newPosition"
          :key="`grid-${idx}`"
          fluid
          grid-list-md
        >
          <p class="font-weight-bold">{{ src.name }}</p>
          <v-layout row wrap>
            <v-flex
              v-for="(item, i) in src.images"
              :key="i"
              md="6"
              xs="12"
              @click="pdfLoader(item)"
            >
              <v-card
                :href="item.link"
                color="transparent"
                flat
                target="_blank"
                :style="{ display: 'flex', flexDirection: isImg ? '' : 'column' }"
              >
                <v-img
                  v-if="isImg"
                  :aspect-ratio="16 / 9"
                  :src="item.url || src.file_link || src.link"
                  class="rounded-lg"
                >
                  <v-card
                    v-if="item.description"
                    class="d-flex align-end fill-height px-2"
                    color="rgba(0, 0, 0, .3)"
                    dark
                    flat
                  >
                    <p v-show="!!src.description" v-html="item.description" />
                  </v-card>
                </v-img>
                <!-- تغییرات اعمال شده برای ویدیو گرید جدید -->
                <div v-else style="position: relative; width: 100%; max-width: 600px; margin: auto; aspect-ratio: 16/9; max-height: 500px; overflow: hidden; border-radius: 8px; background-color: #000;">
                  <iframe
                    :src="item.url || item.file_link || item.link"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"
                  />
                  <span v-if="item.duration" class="duration-badge">{{ item.duration }}</span>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "bGalleryView",

  props: {
    name: { type: String, default: "" },
    value: { type: Array, default: () => [] },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    isImg: { type: Boolean, default: true },
    type: { type: String, default: "" },
    isGrid: { type: Boolean, default: false },
    newPosition: { type: Boolean, default: false },
    settings: { type: Boolean, default: true },
    isSingle: { type: Boolean, default: false },
  },

  data: () => ({
    gallery: "allPic",
    currentItem: 0, // ایندکس مربوط به اسلاید فعال
  }),

  computed: {
    getObj() {
      if (this.gallery === "allPic") {
        let arrays = this.value?.map((item) => item.images);
        return arrays?.reduce((acc, curr) => {
          return acc ? acc.concat(curr || []) : curr;
        }, []);
      }
      return this.value?.find((item) => item.name === this.gallery)?.images || [];
    },
  },

  watch: {
    // هنگام تغییر دسته‌بندی گالری، اسلایدر به اول برمی‌گردد
    gallery() {
      this.currentItem = 0;
    }
  },

  methods: {
    pdfLoader(value) {
      if (this.type === "pdf" && value && value.link) {
        window.open(value.link, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activeBtn {
  color: var(--primary) !important;
  border-bottom: 2px solid var(--primary);
}

/* استایل‌های مربوط به اسلایدر مدرن */
.slider-card {
  position: relative;
  overflow: hidden;
  border-radius: 12px !important;
  width: 100%;
  max-width: 800px; /* جلوگیری از کشیدگی بیش از حد در دسکتاپ */
  box-shadow: 0 4px 20px rgba(0,0,0,0.1) !important;
}

.item-title {
  position: absolute;
  top: 16px;
  right: 16px;
  left: 16px;
  color: white;
  font-size: 1.1rem;
  font-weight: bold;
  text-shadow: 1px 1px 4px rgba(0,0,0,0.8);
  line-height: 1.4;
  z-index: 2;
}

.item-description {
  position: absolute;
  bottom: 50px; /* بالاتر از کنترل‌ها */
  right: 16px;
  left: 16px;
  color: white;
  font-size: 0.9rem;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.8);
  z-index: 2;
}

/* سایه گرادیانت برای واضح شدن کنترل‌ها و متن‌های سفید روی عکس/ویدیو */
.bottom-gradient {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40% !important;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
  z-index: 1;
}

/* غیرفعال کردن کلیک روی گرادیانت ویدیو تا بشود ویدیو را پلی کرد */
.pointer-events-none {
  pointer-events: none;
}

.slider-controls {
  position: absolute;
  bottom: 12px;
  left: 16px;
  right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 3;
}

/* نوار پیشرفت (خطوط تیره) */
.progress-bar-container {
  display: flex;
  gap: 6px;
  flex-grow: 1;
  margin-right: 16px; /* فاصله از دکمه‌ها در حالت RTL */
}

.progress-dash {
  height: 4px;
  flex-grow: 1;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &.active {
    background-color: #ffffff;
    box-shadow: 0 0 4px rgba(0,0,0,0.5);
  }
  
  &:hover {
    transform: scaleY(1.5);
  }
}

/* دکمه‌های ناوبری چپ و راست */
.nav-buttons {
  display: flex;
  gap: 8px;

  .v-btn {
    background-color: rgba(0, 0, 0, 0.4) !important;
    backdrop-filter: blur(4px);
    color: white !important;
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.6) !important;
    }
    
    &.v-btn--disabled {
      background-color: rgba(0, 0, 0, 0.2) !important;
      opacity: 0.5;
    }
  }
}

/* استایل‌های مربوط به هاور عکس‌های قبلی */
.b-gallery-background {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  transition: all 0.3s ease-out;

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 35%;
    width: 100%;
    border-radius: 8px 8px 0 0;
    background: rgba(0, 0, 0, 0.034);
    transition: inherit;
    z-index: 0;
  }
}

.duration-badge {
  position: absolute;
  bottom: 60px; /* بالاتر از کنترل‌های اسلایدر */
  right: 16px; /* در حالت RTL معمولاً پایین راست قرار می‌گیرد */
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
  z-index: 4;
  letter-spacing: 0.5px;
  pointer-events: none;
}
</style>
